import { z } from 'zod';
export const RoomPointSchema = z.object({
    x: z.number(),
    y: z.number(),
});
export const RoomRectSchema = RoomPointSchema.extend({
    width: z.number(),
    height: z.number(),
});
export const RoomDoorSchema = z.object({
    id: z.string().min(1),
    x: z.number(),
    y: z.number(),
    radiusPx: z.number().positive().optional(),
    targetRoomId: z.string().min(1).optional(),
});
export const RoomPortalSchema = RoomRectSchema.extend({
    id: z.string().min(1),
    targetRoomId: z.string().min(1),
    targetSpawnId: z.string().min(1).optional(),
});
export const RoomPuzzleSchema = z.object({
    id: z.string().min(1),
    type: z.string().min(1),
    data: z.record(z.string(), z.unknown()).default({}),
});
export const CanonicalRoomSchema = z.object({
    id: z.string().min(1),
    kind: z.enum(['home', 'town', 'expedition']),
    realm: z.string().min(1).optional(),
    aliases: z.array(z.string().min(1)).default([]),
    tilemapFixture: z.string().min(1).optional(),
    deepTilemapFixture: z.string().min(1).optional(),
    bounds: RoomRectSchema.optional(),
    spawn: RoomPointSchema,
    doors: z.array(RoomDoorSchema).default([]),
    portals: z.array(RoomPortalSchema).default([]),
    wallTiles: z.array(z.number().int().nonnegative()).default([]),
    puzzles: z.array(RoomPuzzleSchema).default([]),
});
export const CanonicalRoomCatalogSchema = z.record(z.string(), CanonicalRoomSchema);
export function validateCanonicalRoom(room) {
    return CanonicalRoomSchema.parse(room);
}
export function validateCanonicalRoomCatalog(catalog) {
    return CanonicalRoomCatalogSchema.parse(catalog);
}
//# sourceMappingURL=schema.js.map